import { Badge } from "@capawesome/capacitor-badge";
import { GroupChannelHandler } from "@sendbird/chat/groupChannel";
import sendbirdSelectors from "@wearesweet/sendbird-uikit-react/sendbirdSelectors";
import { SendBirdState } from "@wearesweet/sendbird-uikit-react/types/lib/types";
import { debug } from "../App";

const updateBadge = async (count: number) => {
  debug("Total unread messages: ", count);
  Badge.requestPermissions()
    .then(() => {
      debug("Badge permissions granted");

      Badge.set({ count: count })
        .then(() => {
          debug("Badge set");
        })
        .catch((error: any) => {
          debug("Badge error", JSON.stringify(error));
        });
    })
    .catch((error: any) => {
      debug("Badge permissions error", JSON.stringify(error));
    });
};

const getUnreadCount = async (state: SendBirdState, setUnreadCount: Function) => {
  const getSdk = sendbirdSelectors.getSdk(state);
  const unreadCount = getSdk?.groupChannel?.getTotalUnreadMessageCount();

  /*if (unreadCount) {
    setUnreadCount(unreadCount);
  }*/

  return unreadCount;
};

export const registerUnreadListener = (state: SendBirdState, setUnreadCount: Function) => {
  const getSdk = sendbirdSelectors.getSdk(state);
  getSdk?.groupChannel?.addGroupChannelHandler(
    "unreadMessagesHandler",
    new GroupChannelHandler({
      onMessageReceived: async (channel, message) => {
        const unread = await getUnreadCount(state, setUnreadCount);
        updateBadge(unread);
      },
    }),
  );
};

export const updateUnreadBadge = async (state: SendBirdState, setUnreadCount: Function) => {
  await updateBadge(await getUnreadCount(state, setUnreadCount));
};
